"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmptyResults = void 0;

var _preact = require("preact");

var EmptyResults = function EmptyResults() {
  return (0, _preact.h)("div", {
    className: "empty-results-container"
  }, (0, _preact.h)("div", {
    className: "empty-results-message"
  }, (0, _preact.h)("div", {
    className: "empty-results-title"
  }, "No results found "), (0, _preact.h)("div", {
    className: "empty-results-description"
  }, " Sorry, that filter combination has no results.", (0, _preact.h)("br", null), " Please try different criteria. ")));
};

exports.EmptyResults = EmptyResults;